import React from 'react'
import { authClient } from '../common/helper'
import { strings } from '../context/LanguageContext/strings'
import AppAnalytics from '../common/AppAnalytics'
import '../style/UnAuthorize.scss'

const UnAuthorize = () =>{
    const onLogoutClick = () =>{
        // Track logout button click
        AppAnalytics.trackAction('logout_clicked', {})
        
        try {
            const localStorageIdToken = localStorage.getItem('id_token')
            const urlLang = new URLSearchParams(window.location.search).get('lang')
            const currentLang = (urlLang && urlLang.replace(/["']/g, '')) || localStorage.getItem('language')
            localStorage.clear()
            if (currentLang) localStorage.setItem('language', currentLang)

            // Attempt logout
            authClient.logout(localStorageIdToken)

            // Track successful logout
            AppAnalytics.trackAction('logout_success', {})
        } catch (error) {
            // Track logout failure
            AppAnalytics.trackAction('logout_failure', {
                error: error.message || 'Unknown error'
            })
            console.error('Logout failed:', error)
        }
    }
    return (
        <div className='unauthorize-container'>
            <h2> {strings.inValidLoginMessage} </h2>
            <button className='btn-login' onClick={ onLogoutClick }  >{strings.logOut}</button>
        </div>
    )
}
export default UnAuthorize